import React, { useState } from 'react';
import { FaEllipsisV } from 'react-icons/fa';
import FollowerActions from './FollowerActions.jsx';
import { useLocale } from '../../contexts/LocaleContext.jsx';
import '../../styles/partial/FollowerCard.css';

/** "September 2026" in the active locale; Unknown when the value is missing or unparseable. */
const formatDate = (dateString, format, t) => format.date(dateString, 'monthYear') || t('common.status.unknown');

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

const FollowerCard = ({ follower, onPromotionSuccess, bandId }) => {
  const { t, format } = useLocale();
  const [isPromoting, setIsPromoting] = useState(false);

  const handlePromotionStart = () => setIsPromoting(true);
  const handlePromotionSuccess = () => {
    setIsPromoting(false);
    onPromotionSuccess();
  };
  const handlePromotionError = () => {
    setIsPromoting(false);
  };

  return (
    <div className={`fcard${isPromoting ? ' fcard--promoting' : ''}`}>
      <div className="fcard__avatar-wrap">
        {follower.profile_image_url ? (
          <img
            src={follower.profile_image_url}
            alt={follower.display_name}
            className="fcard__avatar-img"
          />
        ) : (
          <div className="fcard__avatar-placeholder" aria-hidden="true">
            {getInitials(follower.display_name)}
          </div>
        )}
      </div>

      <div className="fcard__col">
        <span className="fcard__name">{follower.display_name}</span>
        <span className="fcard__since">{t('followers.card.followingSince', { date: formatDate(follower.follow_date, format, t) })}</span>
      </div>

      <FollowerActions
        follower={follower}
        bandId={bandId}
        onPromotionStart={handlePromotionStart}
        onPromotionSuccess={handlePromotionSuccess}
        onPromotionError={handlePromotionError}
        isPromoting={isPromoting}
      />

      {/* placeholder for future context menu — not yet implemented */}
      <button type="button" className="fcard__more-btn" tabIndex={-1} aria-hidden="true">
        <FaEllipsisV />
      </button>
    </div>
  );
};

export default FollowerCard;
